import axiosClient from '../configs/axios';

class SalesReturns {
  async getsalesreturnchallanlist({ cust_id, page = 0, size = 50, searchKey = '' }) {
    try {
      const response = await axiosClient.get(
        `cyl-inward/challanSalesReturn?customer_id=${cust_id}&page=${page}&size=${size}&searchKey=${searchKey}`
      );
      return response.data; // Return the data
    } catch (error) {
      console.error('Error fetching challan numbers:', error.message);
      throw new Error(`Failed to fetch sales return challans: ${error.message}`);
    }
  }



 async getsalesreturnlist({ cust_id, page = 0, size = 999, searchKey = '' }) {
    try {
      const response = await axiosClient.get(
        `sales_return/list?&page=${page}&size=${size}&searchKey=${searchKey}`
      );
      
      return response.data.map(entry => ({
        ...entry,
        table_details: entry.table_details ? JSON.parse(entry.table_details) : [],
      }));
    } catch (error) {
      console.error('Error fetching challan numbers:', error);
      throw error;
    }
  }
}

export default new SalesReturns();